import Dexie, { type Table } from 'dexie';

export interface OfflineTimeEntry {
    id?: string;
    user_id: string;
    organization_id: string;
    project_id?: string | null;
    task_id?: string | null;
    clock_in: string;
    clock_out: string | null;
    status: 'active' | 'paused' | 'completed';
    total_hours: number | null;
    synced: boolean;
    last_updated: string;
}

export class TemporaDatabase extends Dexie {
    timeEntries!: Table<OfflineTimeEntry>;

    constructor() {
        super('TemporaOfflineDB');
        this.version(1).stores({
            timeEntries: '++id, user_id, organization_id, project_id, status, synced, last_updated'
        });
    }
}

export const offlineDB = new TemporaDatabase();
